import React, { Fragment, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useGetKeyHost } from "../../hooks/keyHostManagementApi/getKeyHost";
import Pagination from "../../utils/pagination";
import Header from "../../components/content_wrapper/header";
import { EditSvg, EyeSvg } from "../../utils/svgComponent";
import { useUpdateKeyHostStatus } from "../../hooks/keyHostManagementApi/updateStatus";
import { getCountries, getCountryCallingCode } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { useAddKeyHost } from "../../hooks/keyHostManagementApi/addKeyHost";
import { useFormik } from "formik";
import {
  keyHostValidationSchema,
  keyHostinitialValues,
} from "../../validations/addKeyHostValidation";
import en from "react-phone-number-input/locale/en.json";
import { toast } from "react-toastify";
import { useGetBoxes } from "../../hooks/boxManagementApi/getBoxes";
import KeyHostModal from "./keyHostModal";
import { useUpdateKeyHost } from "../../hooks/keyHostManagementApi/updateKeyHost";
import { useResendPassword } from "../../hooks/keyHostManagementApi/resendHostPassword";
import CustomLaoder from "../../components/customLoader";
export interface TimeSlot {
  day: string;
  start_time: string;
  end_time: string;
  closed: boolean;
}
const days = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

const KeyHostListing: React.FC = () => {
  const initialTimeSlots: TimeSlot[] = days.map((day, index) => ({
    id: index,
    day,
    start_time: "",
    end_time: "",
    closed: false,
  }));
  const [modalState, setModalState] = useState<any>({
    modalType: "",
    open: false,
    data: {},
  });
  const [viewMode, setViewMode] = useState<'table' | 'cards'>('cards');

  const [timeSlots, setTimeSlots] = useState<TimeSlot[]>(initialTimeSlots);
  const [timeError, setTimeError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [getCode, setGetCode] = useState<any>(undefined);
  const [country, setCountry] = useState<any>("");

  const [searchParams, _setSearchParams] = useSearchParams();
  const initialSearch = searchParams.get("search") || "";
  const initialPage: any = parseInt(searchParams.get("page") || "1", 10);
  const initialLimit = parseInt(searchParams.get("limit") || "20", 10);
  // searchInput holds the raw typed value; debouncedSearch is what the query actually uses
  const [searchInput, setSearchInput] = useState<string>(initialSearch);
  const [debouncedSearch, setDebouncedSearch] = useState<string>(initialSearch);
  // statusFilter: '1' = Active, '0' = Disabled, 'all' = All — defaults to Active
  const [statusFilter, setStatusFilter] = useState<string>('1');
  const [pageNumber, setPageNumber] = useState<any>(initialPage);
  const [countData, setCountData] = useState<any>(initialLimit);
  const [passwordModalData, setPasswordMadalData] = useState<any>();
  const [_text, setText] = useState<any>();
  const [copied, setCopied] = useState(false);
  const [copied1, setCopied1] = useState(false);
  // Track which card's ⋮ dropdown is open (by key-host Id)
  const [openDropdownId, setOpenDropdownId] = useState<string | null>(null);

  // Close the dropdown whenever the user clicks anywhere outside it
  useEffect(() => {
    const handleClickOutside = () => setOpenDropdownId(null);
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  // Debounce: wait 400 ms after the user stops typing before firing the API call
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchInput);
      setPageNumber(1); // reset to page 1 on every new search
    }, 400);
    return () => clearTimeout(timer);
  }, [searchInput]);

  const navigate = useNavigate();
  const { data: GetKeyHost, isLoading } = useGetKeyHost({
    page: pageNumber,
    limit: countData,
    search: debouncedSearch,
    status: statusFilter,
  });
  const { data: getBoxesData } = useGetBoxes();
  const BoxItems = getBoxesData?.data;

  const { mutateAsync } = useUpdateKeyHostStatus();
  const handlePrevPage = () => {
    setPageNumber((prevPage: any) => prevPage - 1);
  };

  const handleNextPage = () => {
    setPageNumber((nextPage: any) => nextPage + 1);
  };
  const handleRowLimitChange = (newValue: number) => {
    setCountData(newValue);
  };
  const handleClick = (id: any) => {
    console.log('[KeyHostListing] Navigating to detail with ID:', id);
    if (!id || id === 'undefined') {
      toast.error('Invalid key host ID');
      return;
    }
    navigate(`/keyhostdetail/${id}`, {
      state: {
        id,
      },
    });
  };
  // Dedicated opener for the Edit modal — avoids relying on e.target.title
  const handleEditModalOpen = (data: any) => {
    setModalState({
      modalType: "Edit",
      open: true,
      data: data,
    });
  };

  const _handleToggleClick = async (id: string, action: number) => {
    // key_hosts.status: 1 = active, 0 = disabled
    let Status = action === 1 ? 0 : 1;
    try {
      const res: any = await mutateAsync({
        id: id,
        status: Status,
      });
      if (res.success) {
        toast.success(res?.message);
      } else {
        console.error("Failed to update user status:", res.error);
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
    }
  };

  const {
    values,
    touched,
    errors,
    handleBlur,
    handleChange,
    handleSubmit,
    resetForm,
    setFieldError,
    setFieldValue,
    setValues,
  } = useFormik({
    initialValues: keyHostinitialValues,
    validationSchema: keyHostValidationSchema,
    onSubmit: async () => {
      if (modalState.modalType === "Add") {
        if (hasEmptyTimeSlots === true) {
          setErrorMessage("Please fill in all time slots");
        } else {
          try {
            // Compute selected box IDs from current form values
            const boxIds = values.selectedOption?.map((option: any) => option?._id) || [];
            
            const res: any = await addhostKey({
              user_name: values.username,
              email: values.email,
              country_code: values.countryCode,
              country_name: values?.country,
              phone_number: values.phoneNumber.replace(/^0+/, ""),
              store_name: values.store_name,
              store_info: values.store_info,
              address: values.address,
              latitude: values.lat,
              longitude: values.lng,
              active_time: timeSlots,
              box_id: boxIds,
            });
            if (res?.success === true) {
              toast.success(res?.message);
              handleModalClose();
              setCountry("");
            }
          } catch (error: any) {
            toast.error(error?.response?.data?.message);
          }
        }
      }
      if (modalState.modalType === "Edit") {
        if (hasEmptyTimeSlots === true) {
          setErrorMessage("Please fill in all time slots");
        } else {
          try {
            // Compute selected box IDs from current form values
            const boxIds = values.selectedOption?.map((option: any) => option?._id) || [];
            
            const res: any = await updateAsync({
              id: modalState?.data?._id,
              user_name: values.username,
              email: values.email,
              country_name: values?.country,
              country_code: values.countryCode,
              phone_number: values.phoneNumber.replace(/^0+/, ""),
              store_name: values.store_name,
              store_info: values.store_info,
              address: values.address,
              latitude: values.lat,
              longitude: values.lng,
              active_time: timeSlots,
              box_id: boxIds,
            });
            if (res?.success === true) {
              toast.success(res?.message);
              handleModalClose();
              setCountry("");
            }
          } catch (error: any) {
            toast.error(error?.response?.data?.message);
          }
        }
      } else {
        return null;
      }
    },
  });

  //ADD KEY HOST
  const handleMergeAndSelect = (BoxItems: any = [], values: any) => {
    const alreadySelected =
      modalState?.data?.boxDetails?.map((item: any) => item || "") || [];
    const mergedArray = [...BoxItems, ...alreadySelected];
    const uniqueMergedArray = mergedArray.filter(
      (option, index, self) =>
        index === self?.findIndex((o) => o?._id === option._id)
    );
    const selectedData = values.selectedOption.map(
      (option: any) => option?._id
    );
    return { mergedArray: uniqueMergedArray, selectedData };
  };
  const { mergedArray, selectedData: _selectedData } = handleMergeAndSelect(BoxItems, values);

  const hasEmptyTimeSlots = timeSlots?.some(
    (obj: any) =>
      obj.closed === false &&
      (obj.start_time === "" ||
        obj.start_time === null ||
        obj.end_time === "" ||
        obj.end_time === null)
  );

  useEffect(() => {
    setTimeError(hasEmptyTimeSlots);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeSlots]);
  const handleErrorClick = () => {
    setTimeError(hasEmptyTimeSlots);
    setErrorMessage(hasEmptyTimeSlots ? "Please fill in all time slots" : "");
  };

  const updateTimeSlot = (
    index: number,
    field: string,
    value: string | boolean
  ) => {
    const newTimeSlots = [...timeSlots];
    newTimeSlots[index] = { ...newTimeSlots[index], [field]: value };
    setTimeSlots(newTimeSlots);
  };
  const handleCountryChange = (newCountry: any) => {
    setCountry(newCountry);
  };

  useEffect(() => {
    if (country) {
      const code = getCountryCallingCode(country);
      setGetCode(code);
      if (code) {
        setFieldValue("countryCode", getCode);
      } else {
        setFieldError("countryCode", "country code is required*");
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [country, getCode]);
  const handelPhoneNumber = (newValue: any) => {
    if (newValue) {
      setFieldValue("phoneNumber", newValue);
    } else {
      setFieldError("phoneNumber", "Phone Number is required*");
    }
  };
  const { mutateAsync: addhostKey } = useAddKeyHost();
  const { mutateAsync: updateAsync } = useUpdateKeyHost();

  const onSelected = (selectedList: any, _selectedItem: any) => {
    const uniqueSelectedOptions = selectedList.filter(
      (option: any, index: number, self: any) =>
        index === self.findIndex((o: any) => o === option)
    );
    setFieldValue("selectedOption", uniqueSelectedOptions);
  };
  const onRemove = (selectedList: any, _removeItem: any) => {
    const uniqueSelectedOptions = selectedList.filter(
      (option: any, index: number, self: any) =>
        index === self.findIndex((o: any) => o === option)
    );
    setFieldValue("selectedOption", uniqueSelectedOptions);
  };

  const handleModalOpen = (e: any, data?: any) => {
    if (e.target.title === "Add") {
      setModalState({
        ...modalState,
        modalType: e.target.title,
        open: true,
        data: {},
      });
    }
    if (e.target.title === "Edit") {
      setModalState({
        ...modalState,
        modalType: e.target.title,
        open: true,
        data: data,
      });
    }
  };

  const handleModalClose = () => {
    setModalState({
      ...modalState,
      modalType: "",
      open: false,
      data: {},
    });
    resetForm();
    setCountry("");
    setErrorMessage("");
    setTimeSlots(initialTimeSlots);
  };

  useEffect(() => {
    if (modalState?.modalType === "Edit") {
      setValues({
        address: modalState?.data?.address,
        email: modalState?.data?.email,
        lat: modalState?.data?.location?.coordinates?.[1],
        lng: modalState?.data?.location?.coordinates?.[0],
        store_info: modalState?.data.storeInfo,
        store_name: modalState?.data.storeName,
        username: modalState?.data.userName,
        countryCode: modalState?.data?.countryCode,
        country: modalState?.data?.countryName,
        phoneNumber: JSON.stringify(modalState?.data?.phoneNumber),
        selectedOption: modalState?.data?.boxDetails,
      });
      setTimeSlots(
        modalState?.data?.activeTimes === undefined || null
          ? initialTimeSlots
          : modalState?.data?.activeTimes
      );
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalState?.data]);

  const returnModalChild = () => {
    if (modalState.modalType === "Add") {
      return (
        <KeyHostModal
          modalTitle="Add Key Host"
          setFieldValue={setFieldValue}
          values={values}
          handleChange={handleChange}
          handleBlur={handleBlur}
          errors={errors}
          touched={touched}
          country={country}
          handleCountryChange={handleCountryChange}
          handelPhoneNumber={handelPhoneNumber}
          timeSlots={timeSlots}
          setTimeSlots={setTimeSlots}
          handleSubmit={handleSubmit}
          updateTimeSlot={updateTimeSlot}
          BoxItems={BoxItems}
          handleErrorClick={handleErrorClick}
          timeError={timeError}
          errorMessage={errorMessage}
          selectedOptions={values?.selectedOption}
          onSelected={onSelected}
          onRemove={onRemove}
          isOpen={modalState.open}
          handleModalClose={handleModalClose}
        />
      );
    }
    if (modalState.modalType === "Edit") {
      return (
        <KeyHostModal
          modalTitle="Edit Key Host "
          setFieldValue={setFieldValue}
          values={values}
          handleChange={handleChange}
          handleBlur={handleBlur}
          errors={errors}
          touched={touched}
          country={country}
          handleCountryChange={handleCountryChange}
          handelPhoneNumber={handelPhoneNumber}
          timeSlots={timeSlots}
          setTimeSlots={setTimeSlots}
          handleSubmit={handleSubmit}
          updateTimeSlot={updateTimeSlot}
          handleErrorClick={handleErrorClick}
          timeError={timeError}
          errorMessage={errorMessage}
          BoxItems={mergedArray}
          selectedOptions={values?.selectedOption}
          onSelected={onSelected}
          onRemove={onRemove}
          isOpen={modalState.open}
          handleModalClose={handleModalClose}
        />
      );
    } else return null;
  };

  //resend password
  const { mutateAsync: resendPass } = useResendPassword();
  const _handleModal = (id: any) => {
    const dataItem = GetKeyHost?.data?.keyHosts?.find(
      (data: any) => data._id === id
    );
    if (dataItem) {
      setPasswordMadalData(dataItem);
      setText(dataItem?.email);
    }
  };
  const resendSubmit = async () => {
    try {
      const res: any = await resendPass({
        email: passwordModalData?.email,
      });
      if (res?.success === true) {
        toast.success(res?.message);
        const closeModelButton: any = document.getElementById("close-btn");
        closeModelButton.click();
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
    }
  };

  const handleCopy = (text: string, setCopiedFunc: Function) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setCopiedFunc(true);
        setTimeout(() => {
          setCopiedFunc(false);
        }, 2000);
      })
      .catch((err) => {
        console.error("Failed to copy text: ", err);
      });
  };
  // get name from country code
  const callingCodeToCountry: any = {};
  getCountries().forEach(
    (country) =>
      (callingCodeToCountry[getCountryCallingCode(country)] = country)
  );
  const getCountryNameFromCallingCode = (callingCode: any, _labels: any) =>
    callingCodeToCountry[callingCode] || null;

  const handleConvertCallingCode = (callingCode: any) =>
    getCountryNameFromCallingCode(callingCode, en);

  useEffect(() => {
    if (modalState?.data?.countryCode) {
      const CCode = handleConvertCallingCode(modalState?.data?.countryCode);
      setCountry(CCode);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalState?.data?.countryCode]);
  //
  return (
    <Fragment>
      <div className="main-wrapper">
        <Header title="Key Hosts" />
        <CustomLaoder loader={isLoading}>
          <div className="content-wrapper">
            <section className="main-section coach-section spacer">
              <div className="container">
                <div className="wrapper-card">
                  <div className="row gy-3">
                    {/* Search & View Toggle — full-width incremental search, no Apply/Cancel */}
                    <div className="col-xl-12">
                      <div className="d-flex align-items-center gap-3">

                        {/* Search input — takes all remaining space */}
                        <div className="flex-grow-1 form-block p-relative" style={{ position: 'relative' }}>
                          <input
                            type="text"
                            className="form-control"
                            id="search"
                            placeholder="Search by store name or address…"
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                            autoComplete="off"
                          />
                          <span className="search-icon" />
                          {/* Inline ✕ clear button */}
                          {searchInput && (
                            <button
                              type="button"
                              onClick={() => setSearchInput('')}
                              style={{
                                position: 'absolute',
                                right: '10px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                background: 'none',
                                border: 'none',
                                padding: 0,
                                cursor: 'pointer',
                                color: '#aaa',
                                fontSize: '14px',
                                lineHeight: 1,
                              }}
                              title="Clear search"
                              aria-label="Clear search"
                            >
                              <i className="fa-solid fa-circle-xmark" />
                            </button>
                          )}
                          {/* Subtle loading spinner while debounce is pending */}
                          {isLoading && (
                            <span
                              className="spinner-border spinner-border-sm text-secondary"
                              style={{ position: 'absolute', right: searchInput ? '34px' : '10px', top: '50%', transform: 'translateY(-50%)' }}
                            />
                          )}
                        </div>

                        {/* View toggle — cards / table */}
                        <div className="d-flex gap-2 flex-shrink-0">
                          <button
                            type="button"
                            className={`btn btn-sm ${viewMode === 'cards' ? 'btn-primary' : 'btn-outline-secondary'}`}
                            onClick={() => setViewMode('cards')}
                            title="Card View"
                          >
                            <i className="fa-solid fa-grip" />
                          </button>
                          <button
                            type="button"
                            className={`btn btn-sm ${viewMode === 'table' ? 'btn-primary' : 'btn-outline-secondary'}`}
                            onClick={() => setViewMode('table')}
                            title="Table View"
                          >
                            <i className="fa-solid fa-list" />
                          </button>
                        </div>

                      </div>
                    </div>

                    {/* Status filter pills */}
                    <div className="col-xl-12">
                      <div className="d-flex align-items-center gap-2" style={{ fontSize: '0.875rem' }}>
                        <span className="text-muted me-1">Show:</span>
                        {([
                          { label: '● Active',   value: '1'   },
                          { label: '○ Disabled', value: '0'   },
                          { label: 'All',         value: 'all' },
                        ] as { label: string; value: string }[]).map((f) => (
                          <button
                            key={f.value}
                            type="button"
                            onClick={() => {
                              setStatusFilter(f.value);
                              setPageNumber(1);
                            }}
                            style={{
                              borderRadius: '999px',
                              padding: '3px 14px',
                              fontSize: '0.8rem',
                              fontWeight: statusFilter === f.value ? 600 : 400,
                              cursor: 'pointer',
                              border: `1px solid ${
                                f.value === '1'   ? '#198754' :
                                f.value === '0'   ? '#dc3545' :
                                                    '#6c757d'
                              }`,
                              backgroundColor: statusFilter === f.value
                                ? f.value === '1'   ? '#198754'
                                  : f.value === '0' ? '#dc3545'
                                  :                   '#6c757d'
                                : 'transparent',
                              color: statusFilter === f.value ? '#fff' : (
                                f.value === '1'   ? '#198754' :
                                f.value === '0'   ? '#dc3545' :
                                                    '#6c757d'
                              ),
                              transition: 'all 0.15s',
                            }}
                          >
                            {f.label}
                          </button>
                        ))}
                        {/* Record count hint */}
                        {GetKeyHost?.data?.totalRecord !== undefined && (
                          <span className="text-muted ms-2" style={{ fontSize: '0.78rem' }}>
                            {GetKeyHost.data.totalRecord} result{GetKeyHost.data.totalRecord !== 1 ? 's' : ''}
                          </span>
                        )}
                      </div>
                    </div>

                    {/* Header with Add Button */}
                    <div className="col-xl-12">
                      <div className="sub-heading flex-box">
                        <h2>
                          <i className="fa-solid fa-store me-2" />
                          Key Host Listing
                        </h2>
                        <button
                          onClick={(e: any) => {
                            handleModalOpen(e);
                          }}
                          title="Add"
                          className="btn primary-btn me-0">
                          <i className="fa-solid fa-plus me-2" />
                          Add Host
                        </button>
                      </div>

                      {/* Cards View */}
                      {viewMode === 'cards' && (
                        <div className="row gy-4 mt-2">
                          {GetKeyHost?.data?.keyHosts?.map((data: any, index: number) => (
                            <div key={index} className="col-12 col-md-6 col-lg-4">
                              <div className="card h-100 shadow-sm">
                                <div className="card-body d-flex flex-column">

                                  {/* Row 1: store icon + name/description + status badge + ⋮ menu */}
                                  <div className="d-flex justify-content-between align-items-start mb-3">
                                    <div className="d-flex align-items-center gap-2 flex-grow-1 me-2" style={{ minWidth: 0 }}>
                                      <i className="fa-solid fa-store text-primary" style={{ fontSize: '1.25rem', flexShrink: 0 }} />
                                      <div style={{ minWidth: 0 }}>
                                        <h6 className="mb-0 fw-bold text-truncate">{data?.storeName || 'N/A'}</h6>
                                        <small className="text-muted text-truncate d-block">{data?.storeInfo || ''}</small>
                                      </div>
                                    </div>
                                    <div className="d-flex align-items-center gap-2 flex-shrink-0">
                                      <span className={`c-pill ${data.status === 1 ? 'c-pill--success' : 'c-pill--danger'}`}>
                                        {data.status === 1 ? 'Active' : 'Disabled'}
                                      </span>
                                      {/* ⋮ Actions dropdown — React-controlled (no Bootstrap JS needed) */}
                                      <div style={{ position: 'relative' }}>
                                        <button
                                          type="button"
                                          className="btn btn-sm btn-light px-2 py-1"
                                          title="Actions"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setOpenDropdownId(
                                              openDropdownId === data?._id ? null : data?._id
                                            );
                                          }}
                                        >
                                          <i className="fa-solid fa-ellipsis-vertical" />
                                        </button>
                                        {openDropdownId === data?._id && (
                                          <ul
                                            className="dropdown-menu shadow-sm show"
                                            style={{
                                              position: 'absolute',
                                              right: 0,
                                              top: '100%',
                                              zIndex: 1050,
                                              display: 'block',
                                              minWidth: '150px',
                                            }}
                                          >
                                            <li>
                                              <button
                                                type="button"
                                                className="dropdown-item"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  setOpenDropdownId(null);
                                                  handleClick(data?._id);
                                                }}
                                              >
                                                <i className="fa-solid fa-eye me-2 text-primary" />
                                                View Details
                                              </button>
                                            </li>
                                            <li>
                                              <button
                                                type="button"
                                                className="dropdown-item"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  setOpenDropdownId(null);
                                                  handleEditModalOpen(data);
                                                }}
                                              >
                                                <i className="fa-solid fa-pen-to-square me-2 text-secondary" />
                                                Edit
                                              </button>
                                            </li>
                                          </ul>
                                        )}
                                      </div>
                                    </div>
                                  </div>

                                  {/* Row 2: address & phone (small, matching the icon style) */}
                                  <div className="mb-3">
                                    <div className="d-flex align-items-start mb-1">
                                      <i className="fa-solid fa-location-dot text-danger me-2 mt-1" style={{ fontSize: '0.75rem', flexShrink: 0 }} />
                                      <small className="text-muted">{data?.address || 'No address'}</small>
                                    </div>
                                    <div className="d-flex align-items-center">
                                      <i className="fa-solid fa-phone text-success me-2" style={{ fontSize: '0.75rem', flexShrink: 0 }} />
                                      <small className="text-muted">
                                        {data?.countryCode && data?.phoneNumber
                                          ? `+${data.countryCode} ${data.phoneNumber}`
                                          : 'No phone'}
                                      </small>
                                    </div>
                                  </div>

                                  {/* Row 3: compact inline stats */}
                                  <div className="d-flex align-items-center gap-3 text-muted border-top pt-2 mt-auto" style={{ fontSize: '0.8rem' }}>
                                    <span>
                                      <i className="fa-solid fa-users me-1" style={{ fontSize: '0.75rem' }} />
                                      {data.totalUsers || 0} users
                                    </span>
                                    <span>
                                      <i className="fa-solid fa-key me-1" style={{ fontSize: '0.75rem' }} />
                                      {data.totalKeys || 0} keys
                                    </span>
                                    <span>
                                      <i className="fa-solid fa-box me-1" style={{ fontSize: '0.75rem' }} />
                                      {data.totalBoxes || 0} boxes
                                    </span>
                                  </div>

                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}

                      {/* Table View */}
                      {viewMode === 'table' && (
                        <div className="table-blk table-responsive">
                          <table id="myTable" className="display border-0">
                            <thead>
                              <tr>
                                <th>Store Name</th>
                                <th>Location</th>
                                <th>Phone</th>
                                <th>Users</th>
                                <th>Keys</th>
                                <th>Boxes</th>
                                <th>Status</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {GetKeyHost?.data?.keyHosts?.map(
                                (data: any, index: any) => {
                                  return (
                                  <tr key={index}>
                                    <td>
                                      <span className="table-profile">
                                        <span className="table-profileimg">
                                          <i className="fa-solid fa-store text-primary" />
                                        </span>
                                        <span className="table-username">
                                          {data?.storeName || 'N/A'}
                                        </span>
                                      </span>
                                    </td>
                                    <td>{data?.address || 'N/A'}</td>
                                    <td>
                                      {data?.countryCode && data?.phoneNumber
                                        ? `+${data.countryCode} ${data.phoneNumber}`
                                        : 'N/A'}
                                    </td>
                                    <td>{data.totalUsers || 0}</td>
                                    <td>{data.totalKeys || 0}</td>
                                    <td>{data.totalBoxes || 0}</td>
                                    <td>
                                      <span
                                        className={`c-pill 
                                        ${
                                          data.status === 1
                                            ? "c-pill--success"
                                            : "c-pill--danger"
                                        }`}>
                                        {data.status === 1
                                          ? "Active"
                                          : "Suspended"}
                                      </span>
                                    </td>
                                    <td>
                                      <span className="table-action">
                                        <a
                                          href="#"
                                          onClick={(e) => { e.preventDefault(); handleClick(data?._id); }}
                                          className="table-eye"
                                          style={{ cursor: 'pointer' }}
                                          title="View Details">
                                          <EyeSvg />
                                        </a>
                                        <a
                                          href="#"
                                          onClick={(e) => { e.preventDefault(); handleEditModalOpen(data); }}
                                          className="table-edit"
                                          style={{ cursor: 'pointer' }}
                                          title="Edit">
                                          <EditSvg />
                                        </a>
                                      </span>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                          {GetKeyHost?.data?.keyHosts?.length === 0 ? (
                            <div className="d-flex justify-content-center align-items-center my-3 sub-heading">
                              <h2 className="m-0">No data found</h2>
                            </div>
                          ) : null}
                        </div>
                      )}

                      {GetKeyHost?.data?.keyHosts?.length === 0 && (
                        <div className="d-flex flex-column justify-content-center align-items-center my-5">
                          <i className="fa-solid fa-store fs-1 text-muted mb-3" />
                          <h3 className="text-muted">No Key Hosts Found</h3>
                          <p className="text-muted">Start by adding your first key host</p>
                        </div>
                      )}

                      <Pagination
                        totalPages={GetKeyHost?.data?.totalPage}
                        currentPage={pageNumber}
                        handlePrevPage={handlePrevPage}
                        handleNextPage={handleNextPage}
                        handleRowLimitChange={handleRowLimitChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <div
              className="modal fade common-modal"
              id="resendModal"
              tabIndex={-1}
              aria-labelledby="resendPassword"
              aria-hidden="true">
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-body">
                    <button
                      id="close-btn"
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    />
                    <div className="common-box-body">
                      <h2>Resend Password</h2>

                      <div className="common-modal-form">
                        <div className="common-modal-field">
                          <div className="common-modal-field">
                            <div className="d-flex justify-content-between">
                              <label>Key Host Email</label>
                              {!copied ? (
                                <i
                                  className="fa-regular fa-copy"
                                  style={{
                                    cursor: "pointer",
                                    color: "#72bcb8",
                                  }}
                                  onClick={() =>
                                    handleCopy(
                                      passwordModalData?.email,
                                      setCopied
                                    )
                                  }
                                />
                              ) : (
                                <span style={{ color: "#72bcb8" }}>
                                  Copied!
                                </span>
                              )}
                            </div>

                            <input
                              placeholder="email"
                              className="form-control"
                              type="text"
                              value={passwordModalData?.email || ""}
                              readOnly
                            />
                          </div>
                          <div className="common-modal-field">
                            <div className="d-flex justify-content-between">
                              <label>Key Host Password</label>
                              {!copied1 ? (
                                <i
                                  className="fa-regular fa-copy"
                                  style={{
                                    cursor: "pointer",
                                    color: "#72bcb8",
                                  }}
                                  onClick={() =>
                                    handleCopy(
                                      passwordModalData?.password,
                                      setCopied1
                                    )
                                  }
                                />
                              ) : (
                                <span style={{ color: "#72bcb8" }}>
                                  Copied!
                                </span>
                              )}
                            </div>
                            <input
                              placeholder="email"
                              className="form-control"
                              type="text"
                              value={passwordModalData?.password || ""}
                              readOnly
                            />
                          </div>
                        </div>
                      </div>
                      <div className="common-modal-btns">
                        <button
                          className="btn primary-btn me-0"
                          onClick={() => resendSubmit()}>
                          Resend
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </CustomLaoder>
      </div>
      {returnModalChild()}
    </Fragment>
  );
};

export default KeyHostListing;
